"use strict";

var Backbone = require("backbone");
var _ = require("underscore");
var Router = require("./router");
var Strings = require("./strings");

var UrlUtil = require("@immanens-com/pv5js/common/utils/url-util");
var debug = require("debug")("app"); //https://github.com/visionmedia/debug

/**
 * Retronews Reader App : singleton representing entire application
 */
var ReaderApp = function(options) {
    var T = this;

    T.pv5api = null;
    T.rnapi = null;
    T.version = "2.11.5"; // will be replaced by package version at compile time
    T.lang = "fr";
    T.hostname="www.retronews.fr";
    T.canonicalUrl="https://www.retronews.fr/journal";
    T.canonicalEmbedUrl="https://www.retronews.fr/embed-journal";
    T.trackPage=null;
    T.embed=false;
    T.bot = /bot|googlebot|crawler|spider|robot|crawling/i.test(window.navigator.userAgent); // teste si c'est un robot
    T.user = {
        admin: false,
        premium: false,
        id: 0,
        name: null
    };
    T.googleAnalytics = {
        enable: false,
        path: "/"
    };

    // activate debug message, use debug=* for all messages
    var query_obj = UrlUtil.parseQueryString(window.location.search.replace("?", ""), ["debug"]);
    if (query_obj.debug == "true") {
        localStorage.debug = "*";
    } else if (query_obj.debug == "false") {
        delete(localStorage.debug);
    } else if (query_obj.debug) {
        localStorage.debug = query_obj.debug;
    }

    _.extend(T, options);
    _.extend(T, Backbone.Events); // trigger stuff

    window.STR = Strings[T.lang]; // make strings available globally

    // ezproxy transforme toutes les urls dans le code html, donc on met des | à la place des points
    if(T.hostname){
        T.hostname=T.hostname.replace(/\|/g,".");
    }
    if(T.canonicalUrl){
        T.canonicalUrl=T.canonicalUrl.replace(/\|/g,".");
    }
    if(T.canonicalEmbedUrl){
        T.canonicalEmbedUrl=T.canonicalEmbedUrl.replace(/\|/g,".");
    }
    if(T.pv5api){
        T.pv5api=T.pv5api.replace(/\|/g,".");
    }

    debug("retronews reader %s", T.version);
    debug("debug enable %s", localStorage.debug);

    T.router = new Router({
        app: this
    });

    Backbone.history.start({
        pushState: true,
        root: T.path
    });
};


ReaderApp.prototype.notify = function(data) {
    this.trigger("app:notify", data);
};

ReaderApp.prototype.loginScreen = function() {
    window.alert("Veuillez vous identifier pour ce service");
};

ReaderApp.prototype.premiumScreen = function() {
    window.alert("Service réservé aux abonnés");
};

ReaderApp.prototype.proScreen = function() {
    window.alert("Service réservé aux abonnés pro");
};

ReaderApp.prototype.comingSoonScreen = function() {
    window.alert("Service bientôt disponible");
};

ReaderApp.prototype.addToBasket = function(model) {
    window.alert("Panier: " + JSON.stringify(model.toJSON()));
};

ReaderApp.prototype.help = function() {
    window.open("https://www.retronews.fr/les-fonctionnalites-du-lecteur", "_blank");
};

module.exports = ReaderApp;
